{
  "name": "@allbrainer/sdk",
  "version": "0.1.1",
  "description": "AllBrainer client SDK for tracking and attribution",
  "main": "./dist/index.js",
  "module": "./dist/index.mjs",
  "types": "./dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.mjs",
      "require": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./browser": {
      "import": "./dist/browser.mjs",
      "require": "./dist/browser.js",
      "types": "./dist/browser.d.ts"
    },
    "./package.json": "./package.json"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch",
    "lint": "eslint src/",
    "type-check": "tsc --noEmit"
  },
  "dependencies": {},
  "devDependencies": {
    "@allbrainer/types": "workspace:*",
    "typescript": "^5.3.0",
    "tsup": "^8.0.0",
    "@types/node": "^20.0.0"
  },
  "peerDependencies": {
    "@allbrainer/types": "workspace:*"
  }
}
